import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import ExpertApplicationsTable from "../ExpertApplicationsTable";
import ExpertApplicationDetails from "../ExpertApplicationDetails";

import { ExpertApplication } from "@/types/admin";

interface ApplicationsGridProps {
  applications: ExpertApplication[];
  selectedApplication: ExpertApplication | null;
  adminNotes: string;
  onSelectApplication: (application: ExpertApplication) => void;
  onSetAdminNotes: (notes: string) => void;
  onStatusUpdate: (applicationId: string, status: 'approved' | 'rejected') => void;
  onDelete: (applicationId: string) => void;
  onClose: () => void;
}

export default function ApplicationsGrid({
  applications,
  selectedApplication,
  adminNotes,
  onSelectApplication,
  onSetAdminNotes,
  onStatusUpdate,
  onDelete,
  onClose
}: ApplicationsGridProps) {
  return (
    <div className="space-y-8">
      {/* Applications Table */}
      <Card>
        <CardContent className="p-0">
          <ExpertApplicationsTable
            applications={applications}
            onSelectApplication={onSelectApplication}
            selectedApplicationId={selectedApplication?.id}
          />
        </CardContent>
      </Card>

      {/* Application Details Below Table */}
      {selectedApplication && (
        <ExpertApplicationDetails
          application={selectedApplication}
          adminNotes={adminNotes}
          setAdminNotes={onSetAdminNotes}
          onStatusUpdate={onStatusUpdate}
          onDelete={onDelete}
          onClose={onClose}
        />
      )}
    </div>
  );
}
